import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: HomeView
  },
  {
    path: '/resolve',
    name: 'resolve',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/resolve'),
  },
  {
    path: '/shanglian',
    name: 'shanglian',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/scheme/shanglian'),
  },
  {
    path: '/puhui',
    name: 'puhui',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/scheme/puhui'),
  },
  {
    path: '/consult',
    name: 'consult',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/consult'),
  },
  // 数据科技
  {
    path: '/science',
    name: 'science',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/science'),
  },
  // 关于我们
  {
    path: '/inRegardTo',
    name: 'inRegardTo',
    meta: {
      title: "北京牛加科技发展有限公司",
    },
    component: () => import('@/views/inRegardTo'),
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
